export default __webpack_public_path__ + "static/media/error-icon.2d673bf5.svg";